import React from 'react'

const WidthContext = React.createContext();

export const WidthProvider = WidthContext.Provider
export const WidthConsumer = WidthContext.Consumer


export default WidthContext